import {
  GoalFilterDocument,
  GoalGroupBy,
  GoalSortingMode,
  GroupByMode,
} from '@griply/types';

export type GoalListControlSource = {
  goalFilterDocument?: GoalFilterDocument | null;
  goalSortingMode?: GoalSortingMode | null;
  // Projects nest under their parent goal by default; goal lists are flat.
  defaultGroupByMode?: GoalGroupBy;
};

// The entity's `goalSortingMode` (not the document) drives the list sort.
export const getGoalListControlDocument = ({
  goalFilterDocument,
  goalSortingMode,
  defaultGroupByMode = GroupByMode.None,
}: GoalListControlSource): GoalFilterDocument => ({
  ...(goalFilterDocument ?? {}),
  sortingMode:
    goalFilterDocument?.sortingMode ??
    goalSortingMode ??
    GoalSortingMode.StartDate,
  groupByMode: goalFilterDocument?.groupByMode ?? defaultGroupByMode,
  filters: goalFilterDocument?.filters ?? null,
});
